import RegionalConfigModel from './components/RegionalConfigs/RegionalConfigModel';

/**
 * Loads the regional configuration from the API if it does not already exist in localStorage.
 * If the configuration is successfully retrieved, it is saved to localStorage.
 * If the API call fails, it logs an error to the console.
 *
 * @function loadConfig
 * @returns {void}
 */
export const loadConfig = (reload = false) => {
  const configFromStorage = localStorage.getItem('regionalConfig');

  if (!reload && configFromStorage) {
    return;
  }

  RegionalConfigModel.getOne({ id: 'XGFF-GSD' })
    .then((response) => {
      const config = response?.regional_config;

      if (config) {
        localStorage.setItem('regionalConfig', JSON.stringify(config));
      }
    })
    .catch((error) => console.error('Failed to load config:', error));
};

/**
 * Retrieves the regional configuration from localStorage.
 * If no configuration is found, returns a default configuration.
 *
 * @function getRegionalConfig
 * @returns {Object} The regional configuration or default values.
 * @returns {string} return.currency - The currency code (default: 'USD').
 * @returns {string} return.currency_symbol - The symbol for the currency (default: '$').
 */
export const getRegionalConfig = () => {
  const configFromStorage = localStorage.getItem('regionalConfig');

  return configFromStorage
    ? JSON.parse(configFromStorage)
    : {
      currency: 'USD',
      currency_symbol: '$'
    };
};
